var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.858,
    height: 17.012,
    viewBox: "0 0 12.858 17.012",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12786",
    "data-name": "Path 12786",
    d: "M19.243,18.728l-2.414-6.889a5.121,5.121,0,1,0-8.039.2L6.445,18.728a.527.527,0,0,0,.77.625l2.18-1.32,1.056,2.319a.526.526,0,0,0,.479.309h.044a.528.528,0,0,0,.466-.389l1.4-5.236,1.4,5.236a.527.527,0,0,0,.465.389h.043a.525.525,0,0,0,.479-.309l1.056-2.319,2.179,1.32a.528.528,0,0,0,.771-.625M10.8,18.579l-.693-1.522a.527.527,0,0,0-.753-.232l-1.431.866,1.7-4.839a5.152,5.152,0,0,0,2.446,1.007Zm2.012-5.72c-.027,0-.054,0-.082,0a4.08,4.08,0,1,1,.113,0h-.031m3.518,3.966a.526.526,0,0,0-.753.232l-.693,1.522-1.276-4.753a5.149,5.149,0,0,0,2.408-1.114l1.744,4.978Z",
    transform: "translate(-6.415 -3.649)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedal);
export default __webpack_public_path__ + "static/media/icon-medal.217367915087532aa8ef6da1fcd337b2.svg";
export { ForwardRef as ReactComponent };